module.exports = __webpack_public_path__ + "img/negroni.374d9445.jpg";